var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.fieldType.metaComponents),function(meta,i){return _c('div',{key:i},[_c(meta,{tag:"div",attrs:{"field":_vm.internalValue},on:{"updateFieldAttribute":_vm.handleUpdate,"updateFieldMeta":_vm.handleMetaUpdate}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }